import { IDashboardStatisitc } from '../interfaces/dashboard';
import * as baseAdapter from './baseAdapter';

export const queryStatistic = async () => {
  const ret = await baseAdapter.get<IDashboardStatisitc>(
    '/dashboard/statistic',
  );
  return ret;
};
